import butterflyImg from "@/assets/wildlife-butterfly-coneflower.jpg";
import beeImg from "@/assets/wildlife-bee-pollinator.jpg";
import hummingbirdImg from "@/assets/wildlife-hummingbird-garden.jpg";

const cards = [
  {
    image: butterflyImg,
    alt: "Monarch butterfly on a native coneflower in a meadow garden",
    label: "Butterflies",
    description: "Native blooms provide essential nectar and host plants for monarchs and swallowtails.",
  },
  {
    image: beeImg,
    alt: "Native bee pollinating wild bergamot in a habitat garden",
    label: "Native Pollinators",
    description: "Support 4,000+ native bee species with the plants they evolved alongside.",
  },
  {
    image: hummingbirdImg,
    alt: "Ruby-throated hummingbird hovering near bee balm in a native garden",
    label: "Songbirds & Hummingbirds",
    description: "Native shrubs and flowers provide food, shelter, and nesting habitat year-round.",
  },
];

const WildlifeEcosystemStrip = () => {
  return (
    <section className="py-16 md:py-24 bg-muted/40">
      <div className="container max-w-5xl">
        <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-3">
          Native Gardens Support Real Ecosystems
        </h2>
        <p className="text-center text-muted-foreground text-sm sm:text-base mb-12 max-w-lg mx-auto">
          Every plant in your plan is chosen to feed, shelter, and sustain local wildlife.
        </p>
        <div className="grid sm:grid-cols-3 gap-6">
          {cards.map((card) => (
            <div
              key={card.label}
              className="rounded-xl overflow-hidden border border-border/40 bg-card shadow-sm hover:shadow-md transition-shadow"
            >
              <img
                src={card.image}
                alt={card.alt}
                className="w-full aspect-square object-cover"
                width={400}
                height={400}
                loading="lazy"
              />
              <div className="p-4">
                <h3 className="font-semibold text-sm sm:text-base text-foreground mb-1">
                  {card.label}
                </h3>
                <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WildlifeEcosystemStrip;
